import { Box, Stack, SxProps, Theme, Typography } from '@mui/material';
import { useThemeContext } from '../../hook/useThemeManager';
import { theme } from '../../constants/theme';
import { FONT_ENUM } from '../../types/global/fonts.types';
import { currencyConverter } from '../../utils/responseProcessor';
import AwardIcon from '../CustomSVGIcons/AwardIcon';
import CloseIconWithBG from '../CustomSVGIcons/CloseIconWithBG';
import { PrizeD } from '../../types/global/helper';
import { isEmpty } from '../../utils/lodash';

export type TPrize =
    | 'Jury Selection'
    | 'Audience Awards'
    | 'Second Place'
    | 'Third Place'
    | 'Fourth Place'
    | 'Fifth Place'
    | 'Sixth Place'
    | 'Special Recognition';

export interface IContestAwardTab {
    data: PrizeD;
    onRemovePrize?: (data: PrizeD) => void;
    isSelectable?: boolean;
    sx?: SxProps<Theme>;
    onSelect?: () => void;
}

const ContestPrize: React.FC<IContestAwardTab> = ({ data, onRemovePrize, isSelectable, sx, onSelect }) => {
    const { themeStyle } = useThemeContext();
    return (
        <Stack
            width="fit-content"
            direction="row"
            height="fit-content"
            alignItems="center"
            border={`0.2px solid ${theme[themeStyle].darkGray60}`}
            padding={2}
            position="relative"
            bgcolor={theme[themeStyle].deep_grey_lighter}
            mr={1.2}
            mb={1.2}
            borderRadius={2}
            onClick={onSelect}
            sx={sx}>
            {!isSelectable && (
                <Box
                    onClick={() => onRemovePrize && onRemovePrize(data)}
                    sx={{
                        position: 'absolute',
                        right: -5,
                        top: -5,
                        cursor: 'pointer',
                    }}>
                    <CloseIconWithBG height={'20px'} width={'20px'} />
                </Box>
            )}
            <AwardIcon
                height={50}
                width={50}
                stroke={theme[themeStyle].tertiary_dark}
                fill={theme[themeStyle].tertiary_dark}
                style={{
                    margin: '10px',
                }}
            />
            <Box>
                <Typography
                    sx={{
                        color: theme[themeStyle].highlight,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 8,
                    }}>
                    Award Title
                </Typography>
                <Typography
                    sx={{
                        color: theme[themeStyle].tag_white,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 12,
                        textTransform: 'capitalize',
                    }}>
                    {data.category_title} - {data.sub_category}
                </Typography>
                <Typography
                    sx={{
                        color: theme[themeStyle].highlight,
                        fontFamily: FONT_ENUM.MAIN_MEDIUM,
                        fontSize: 8,
                    }}>
                    Prize
                </Typography>
                {Number(data.prize) > 0 && (
                    <Typography
                        sx={{
                            color: theme[themeStyle].tag_white,
                            fontFamily: FONT_ENUM.MAIN_MEDIUM,
                            fontSize: 12,
                            textTransform: 'capitalize',
                        }}>
                        ${currencyConverter(Number(data.prize))}
                    </Typography>
                )}

                {data &&
                    data.additional_prize &&
                    !isEmpty(data.additional_prize) &&
                    data.additional_prize.map((prize: string, index: number) => (
                        <Typography
                            key={index}
                            sx={{
                                fontFamily: FONT_ENUM.MAIN_MEDIUM,
                                color: theme[themeStyle].primary_white,
                                fontSize: 8,
                            }}>
                            • {prize}
                        </Typography>
                    ))}
            </Box>
        </Stack>
    );
};

ContestPrize.defaultProps = {
    data: {
        category_title: 'Audience Awards',
        prize: '300000',
    },
};

export { ContestPrize };
